<div style="height: 100%;width:100%;">
	<div class="app-header">
		<app-pane-header></app-pane-header>
	</div>
	<div class="container-pane" style="width:100%;">
		<router-outlet></router-outlet>
	</div>
	<!-- <app-common-socket-msg #socketMsgPane [hidden]="!socketProcesses.length" [processes]="socketProcesses" [operations]="funcsByProcessType"></app-common-socket-msg> -->
</div>

<app-common-template-refs></app-common-template-refs>